import React from 'react';
import { Trash2, AlertCircle } from 'lucide-react';

interface DeleteConfirmDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
  isArchived: boolean;
  title?: string;
  message?: string;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({ 
  onConfirm, 
  onCancel, 
  isArchived,
  title = "Gebäude löschen",
  message = "Möchten Sie dieses Gebäude wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex items-center mb-4">
          <div className="bg-red-100 p-2 rounded-full mr-4">
            <Trash2 className="h-6 w-6 text-red-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-800">{title}</h2>
        </div>
        
        <p className="text-gray-600 mb-6">
          {message}
        </p>
        
        <div className="bg-red-50 p-4 rounded-md mb-6 flex items-start">
          <AlertCircle className="h-5 w-5 text-red-500 mr-2 mt-0.5 shrink-0" />
          <div>
            <p className="text-sm text-red-700 font-medium">
              Achtung: Alle Daten werden unwiderruflich gelöscht!
            </p>
            {!isArchived && (
              <p className="text-sm text-red-700 mt-1">
                Tipp: Sie können das Gebäude auch archivieren, um es später wiederherzustellen.
              </p>
            )}
          </div>
        </div>
        
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            Abbrechen
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center gap-1"
          >
            <Trash2 className="w-4 h-4" />
            Löschen
          </button>
        </div>
      </div>
    </div>
  );
};